// operation types for company
export enum OperationType {
  CONTRACT = "Contract",
  SCHOOL = "School",
  DAILY_BUS = "Daily Bus",
  TOUR_BOOKING = "Tour Booking",
  LARGE_FLEET = "Large Fleet",
  LARGE_FLEET_ALL = "Large Fleet All",
  ALL = "All",
}

// user scope
export enum UserScope {
  GLOBAL = "GLOBAL",
  PROJECT = "PROJECT",
}

// User Permissions - Simplified boolean-based structure
export interface UserPermissions {
  canViewDashboard: boolean;
  canViewOperations: boolean;
  canViewFinance: boolean;
  canViewRecentActivity: boolean;
  canViewTrips: boolean;
  canViewTrip: boolean;
  canCreateTrip: boolean;
  canEditTrip: boolean;
  canEditTripBasic: boolean;
  canCompleteTrip: boolean;
  canDeleteTrip: boolean;
  canRecoverAdvance: boolean;
  canViewVehicleExpense: boolean;
  canCreateVehicleExpense: boolean;
  canEditVehicleExpense: boolean;
  canDeleteVehicleExpense: boolean;
  canViewOtherExpense: boolean;
  canCreateOtherExpense: boolean;
  canEditOtherExpense: boolean;
  canDeleteOtherExpense: boolean;
  canViewTripPNL: boolean;
  canViewTripLedger: boolean;
  canViewIncomeReport: boolean;
  canViewExpenseReport: boolean;
  canViewFuelReport: boolean;
  canViewMaintenanceReport: boolean;
  canViewCommissionReport: boolean;
  canViewPickupReport: boolean;
  canViewDriverCleanerReport: boolean;
  canViewReportByVehicles: boolean;
  canViewCompany: boolean;
  canEditCompany: boolean;
  canViewUsers: boolean;
  canCreateUser: boolean;
  canEditUser: boolean;
  canViewVehicles: boolean;
  canViewVehicle: boolean;
  canCreateVehicle: boolean;
  canEditVehicle: boolean;
  canViewVehicleFinance: boolean;
  canCreateVehicleFinance: boolean;
  canEditVehicleFinance: boolean;
  canViewVehicleMaintenance: boolean;
  canCreateVehicleMaintenance: boolean;
  canEditVehicleMaintenance: boolean;
  canViewVehicleDocument: boolean;
  canUploadVehicleDocument: boolean;
  canUpdateVehicleDocument: boolean;
  canViewVehicleInsurance: boolean;
  canCreateVehicleInsurance: boolean;
  canEditVehicleInsurance: boolean;
  canViewVehiclePermit: boolean;
  canCreateVehiclePermit: boolean;
  canEditVehiclePermit: boolean;
  canViewVehicleOdometer: boolean;
  canViewDriver: boolean;
  canCreateDriver: boolean;
  canBlacklistDriver: boolean;
  canEditDriver: boolean;
  canViewCleaner: boolean;
  canCreateCleaner: boolean;
  canBlacklistCleaner: boolean;
  canEditCleaner: boolean;
  canViewLadyAttendant: boolean;
  canCreateLadyAttendant: boolean;
  canBlacklistLadyAttendant: boolean;
  canEditLadyAttendant: boolean;
  canViewSupervisor: boolean;
  canCreateSupervisor: boolean;
  canBlacklistSupervisor: boolean;
  canEditSupervisor: boolean;
  canViewRoute: boolean;
  canCreateRoute: boolean;
  canEditRoute: boolean;
  canViewServiceOperator: boolean;
  canCreateServiceOperator: boolean;
  canEditServiceOperator: boolean;
  canViewParty: boolean;
  canCreateParty: boolean;
  canEditParty: boolean;
  canViewBranch: boolean;
  canCreateBranch: boolean;
  canEditBranch: boolean;
  canViewPickupMan: boolean;
  canCreatePickupMan: boolean;
  canEditPickupMan: boolean;
  canViewPetrolPump: boolean;
  canCreatePetrolPump: boolean;
  canEditPetrolPump: boolean;
  canViewParkingLocation: boolean;
  canCreateParkingLocation: boolean;
  canEditParkingLocation: boolean;
  canViewGarage: boolean;
  canCreateGarage: boolean;
  canEditGarage: boolean;
  canViewMechanic: boolean;
  canCreateMechanic: boolean;
  canEditMechanic: boolean;
  canViewBooking: boolean;
  canCreateBooking: boolean;
  canEditBooking: boolean;
  canViewDailyLogs: boolean;
  canCreateDailyLogs: boolean;
  canEditDailyLogs: boolean;
  canDeleteDailyLogs: boolean;
  canViewBookingExpense: boolean;
  canCreateBookingExpense: boolean;
  canEditBookingExpense: boolean;
  canDeleteBookingExpense: boolean;
  canViewBookingIncome: boolean;
  canCreateBookingIncome: boolean;
  canEditBookingIncome: boolean;
  canDeleteBookingIncome: boolean;
  canViewContract: boolean;
  canDeleteExpense: boolean;
}

export enum tabType {
  DASHBOARD = "DASHBOARD",
  TRIP = "TRIP",
  VEHICLE_EXPENSE = "VEHICLE_EXPENSE",
  OTHER_EXPENSE = "OTHER_EXPENSE",
  REPORTS = "REPORTS",
  FUEL_REPORTS = "FUEL_REPORTS",
  MAINTENANCE_REPORTS = "MAINTENANCE_REPORTS",
  COMPANY = "COMPANY",
  USER = "USER",
  VEHICLE = "VEHICLE",
  VEHICLE_FINANCE = "VEHICLE_FINANCE",
  VEHICLE_MAINTENANCE = "VEHICLE_MAINTENANCE",
  VEHICLE_DOCUMENT = "VEHICLE_DOCUMENT",
  VEHICLE_INSURANCE = "VEHICLE_INSURANCE",
  VEHICLE_PERMIT = "VEHICLE_PERMIT",
  VEHICLE_ODOMETER = "VEHICLE_ODOMETER",
  MASTER_DATA = "MASTER_DATA",
  BOOKING = "BOOKING",
  CONTRACT = "CONTRACT",
}
